<ng-template #rightOutlet>
  <rt-icon [name]="isMinimized ? 'expand-more' : 'expand-less'" class="icon-right"></rt-icon>
</ng-template>

<div *ngIf="items.length > 0">
  <rt-sidebar-item
    [name]="heading"
    [icon]="icon"
    [iconActive]="!isMinimized && !sidebarMinimized"
    [rightOutlet]="rightOutlet"
    [href]="sidebarMinimized ? items[0].url : undefined"
    [type]="ItemType.Heading"
    [hoverable]="false"
    (click)="onHeaderClick()"
    [attr.border-top]="!isFirst ? true : null"
    class="heading sidebar-label sidebar-group-heading"
  ></rt-sidebar-item>
  <div class="group" [@collapse]="visibilityState">
    <rt-sidebar-item
      *ngFor="let item of items; trackBy: trackByName"
      [name]="item.name"
      [href]="item.url"
      [rtcAnalyticsTrack]="item.analyticsEvent"
      [rtcAnalyticsTrackData]="item.analyticsEventData"
      [rightOutlet]="item.rightOutlet!"
      [rightOutletContext]="item.rightOutletContext!"
      [active]="isActive(item)"
      [type]="ItemType.Item"
    ></rt-sidebar-item>
  </div>
</div>
